import { render, staticRenderFns } from "./CourseListItem.vue?vue&type=template&id=848cc404"
import script from "./CourseListItem.vue?vue&type=script&lang=js"
export * from "./CourseListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports